import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Map from './components/Map/Map'
import StoreList from './components/List/StoreList';
import { SiteContext } from './context/siteContext'
import { FilterContext } from './context/filterContext'
import './App.css';

function App() {

  const [markers, setMarkers] = useState([])
  const [filterData, setFilterData] = useState([])
  const [brand,setBrand]=useState('')

  useEffect(() => {
    axios.get("https://maps.rt-itservices.co.uk?site=Tubbees").then((res) => {
      setMarkers(res.data.sites)
      setFilterData(res.data.sites)
      setBrand(res.data.brand)
    }).catch((err) => {
      console.log(err)
    })
  }, [])

  return (
    <>
      <SiteContext.Provider value={{ markers, setMarkers }}>
      <FilterContext.Provider value={{ filterData, setFilterData }}>
        <div className="container-fluid">
          <br />
          <div>
            <Map brand={brand}/>
          </div>
          <div className="my-4 row row-cols-1 row-cols-md-2 row-cols-lg-3">
            <StoreList/>
          </div>
          <div>
          </div>
        </div>
        </FilterContext.Provider>
      </SiteContext.Provider>
    </>
  );
}

export default App;
